import React, { useCallback, useEffect, useState } from "react";
import { Box } from "@mui/material";
import styles from "./vehicleDetailComponent.module.scss";
import TextLabel from "../../../../components/textLabelComponent/TextLabelComponent";
import SubTitleHeader from "../../../../components/subTitleHeader/SubTitleHeader";
import FooterButtonSection from "../../../../components/footerSection/FooterButtonSection";
import _ from "lodash";
import VehicelIconComponen from "./vehicleIconComponent/VehicleIconComponent";
import LicensePlateComponent from "../../../../components/licensePlateComponent/LicensePlateComponent";
import moment from "moment";
import i18next from "i18next";
import { getVehicleDetails } from "../../../../services/APIService";
import { useApiErrorModalContext } from "../../../../errorHandling/ApiErrorModalContext";
import CustomSnackbar from "../../../../components/customSnackBar/CustomSnackbar";
import PropTypes from "prop-types";

const VehiclesDeatilComponent = (props) => {
  const {
    vehicleId,
    setEditDrawerState,
    setVehicleDetailsDrawerState,
    setVehicleLogsDrawerState,
  } = props;

  const handleEditClick = () => {
    document.getElementById("contentWrapper")?.scrollIntoView();

    setVehicleDetailsDrawerState(false);
    setEditDrawerState(true);
  };

  const handleLogsClick = () => {
    document.getElementById("contentWrapper")?.scrollIntoView();

    setVehicleDetailsDrawerState(false);
    setVehicleLogsDrawerState(true);
  };

  const [vehicelsDetails, setVehicelsDetails] = useState({});
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [emailStatus, setEmailStatus] = useState(true);
  const { setApiErrorModalState } = useApiErrorModalContext();

  const emailSuccessfull = "Email sent successfully";
  const emailFail = "Email not sent";
  useEffect(() => {
    getVehicleDetails({ vehicleId: vehicleId })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setVehicelsDetails(response);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const refreshTable = useCallback(() => {
    getVehicleDetails({ vehicleId: vehicleId })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setVehicelsDetails(response);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });
  return (
    <Box className={styles.vehicleDetailWrapper} data-testid="vehiclesdetails">
      <Box className={styles.vehiclesDetails1}>
        <Box className={styles.vehiclesDetails2}>
          <Box className="textboxDoubleWraper">
            <LicensePlateComponent
              platenumber={_.get(vehicelsDetails, "license_Plate_No", "-")}
            />
          </Box>
          <Box className="textboxDoubleWraper">
            <TextLabel
              label="VIN no."
              value={_.get(vehicelsDetails, "vin", "-")}
            />
          </Box>
          <Box className="textboxDoubleWraper">
            <TextLabel
              label="Type of vehicle"
              value={_.get(vehicelsDetails, "type", "-")}
            />
          </Box>
          <Box className="textboxThreeItemraper">
            <TextLabel
              label="Make"
              value={_.get(vehicelsDetails, "make", "-")}
            />
            <TextLabel
              label="Model"
              value={_.get(vehicelsDetails, "model", "-")}
            />
            <TextLabel
              label="Milage Kms."
              value={_.get(vehicelsDetails, "kilometer_Stand", "-")}
            />
          </Box>
          <Box className="textboxDoubleWraper">
            <TextLabel
              label="Date of 1st  admission"
              value={moment(
                _.get(vehicelsDetails, "date_of_Admission", "-")
              ).format("DD-MM-YYYY")}
            />
          </Box>
          <Box className="textboxDoubleWraper">
            <TextLabel
              label="Dealer"
              value={`${_.get(vehicelsDetails, "dealer_Id", "-")} : ${_.get(
                vehicelsDetails,
                "dealer_Name",
                "-"
              )}`}
              hasLink={false}
            />
            <TextLabel
              label="Laatste  bericht"
              value={
                _.isNull(_.get(vehicelsDetails, "last_Updated_Date", "-"))
                  ? moment(
                      _.get(vehicelsDetails, "creation_Date", "-")
                    ).format("DD-MM-YYYY")
                  : moment(
                      _.get(vehicelsDetails, "last_Updated_Date", "-")
                    ).format("DD-MM-YYYY")
              }
            />
          </Box>
          {!_.isEmpty(_.get(vehicelsDetails, "certificates", [])) && (
            <Box className={styles.assignWrapper}>
              <SubTitleHeader title="Assigned certificate" />

              <VehicelIconComponen
                vehicleId={vehicleId}
                vehicle={vehicelsDetails}
                certificatesList={_.get(vehicelsDetails, "certificates", [])}
                refreshTable={refreshTable}
                setOpenSnackBar={setOpenSnackBar}
                setEmailStatus={setEmailStatus}
              />
            </Box>
          )}
          <Box className="textboxDoubleWraper">
            <TextLabel
              label="Advertisement status"
              value={i18next.t(
                _.get(vehicelsDetails, "ad_Status", 0) === 0
                  ? "Inactief"
                  : "Actief"
              )}
            />
          </Box>
        </Box>
        <FooterButtonSection
          btnlist={[
            {
              title: "View logs",
              iconStyle: "",
              buttonType: "muibtn-secondary-with-border-without-icon",
              attriType: "button",
              withIcon: false,
              showCountSection: false,
              count: "",
              handleClick: () => handleLogsClick(),
            },
            {
              title: "Edit details",
              iconStyle: "",
              buttonType: "muibtn-primary",
              attriType: "button",
              withIcon: false,
              showCountSection: false,
              count: "",
              handleClick: () => handleEditClick(),
            },
          ]}
        />
      </Box>
      {openSnackBar ? (
        <CustomSnackbar
          open={openSnackBar}
          message={emailStatus ? emailSuccessfull : emailFail}
          setOpen={setOpenSnackBar}
          successMessage={emailStatus}
        />
      ) : null}
    </Box>
  );
};

export default VehiclesDeatilComponent;
VehiclesDeatilComponent.propTypes = {
  vehicleId: PropTypes.any,
  setEditDrawerState: PropTypes.any,
  setVehicleDetailsDrawerState: PropTypes.any,
  setVehicleLogsDrawerState: PropTypes.any,
};
